export default {
  logo: "/img/cadnet.jpeg",
  rtl: true
};
